import React from 'react';
import { Check } from 'lucide-react';
export function FinalCTA() {
  const items = ['Manual para Padres', 'Plan 21 Días', 'Workbook Imprimible', 'Checklist de Progreso', 'Guía Anti Frustración', 'Bono: Juegos Fonológicos', 'Bono: Calendario Visual', 'Bono: Mini Biblioteca Inicial', 'Bono: Audio Calmante', 'Garantía 7 días', 'Acceso inmediato', 'Actualizaciones incluidas'];
  return <section className="w-full bg-[#EDE8DF] py-20 md:py-28 px-4" data-id="element-33">
      <div className="max-w-4xl mx-auto text-center" data-id="element-34">
        <h2 className="text-3xl md:text-5xl font-bold text-dark font-serif mb-12 leading-tight" data-id="element-35">
          Hoy no estás pagando por un PDF. <br data-id="element-36" />
          <span className="text-olive" data-id="element-37">
            Estás llevando a casa un sistema completo.
          </span>
        </h2>

        <div className="bg-white/50 rounded-3xl p-8 md:p-12 mb-12 inline-block w-full max-w-2xl border border-white shadow-sm" data-id="element-38">
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4 text-left" data-id="element-39">
            {items.map((item, index) => <li key={index} className="flex items-center space-x-3" data-id="element-40">
                <div className="bg-gold/20 rounded-full p-1" data-id="element-41">
                  <Check className="w-3 h-3 text-gold-dark stroke-[3]" data-id="element-42" />
                </div>
                <span className="text-dark font-medium" data-id="element-43">{item}</span>
              </li>)}
          </ul>
        </div>

        <div className="space-y-8" data-id="element-44">
          <p className="text-xl md:text-2xl text-terracotta font-serif italic" data-id="element-45">
            "Es tranquilidad. Es dirección. Es confianza para vos y para él."
          </p>

          <div className="flex flex-col items-center space-y-4" data-id="element-46">
            <button onClick={() => window.open('https://www.gaiadigitalpro.com/checkouts/cn/hWN91detKUA3JZvySec9CenJ/es-ar?_r=AQABrOvx_mroREqaZDGTff6UkVA7_iuSpYNGcQFEgzuoo40&preview_theme_id=163059597347', '_blank')} className="hover:bg-terracotta-light text-white font-serif text-xl px-12 py-5 rounded-full shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-1 w-full md:w-auto bg-[#6FC628]" data-id="element-47">
              Sí, quiero empezar hoy mismo
            </button>

            <p className="text-olive font-medium text-sm flex items-center" data-id="element-48">
              <span className="mr-2" data-id="element-49">✦</span> Más de 3.000 familias ya
              comenzaron su camino lector
            </p>
          </div>
        </div>
      </div>
    </section>;
}